import {createBrowserHistory } from "history";
import { configureStore, combineReducers} from "@reduxjs/toolkit";
import deviceReducer from "../Devices/Slice";
import alarmReducer from '../Alarms/Slice';
import sidebarReducer from "../Common/Slices/SidebarSlice";
import menuReducer from "../Common/Slices/MenuSlice";
import dashboardReducer from "../Common/Slices/DashboardSlice";
import paramsReducer, { updateParams } from "../Common/Slices/ParamSlice";
import machineHealthReducer from "../MachineHealth/machineHealthSlice";
import authReducer from "../Core/Slice";
import optionsReducer from "../Common/Slices/optionSlice"
import machineTimesReducer from "../MachineTimes/slice";
import mdcReducer from "../MDC/mdcSlice";
import runningPeriodsOptionsReducer from "../RunningPeriods/runningPeriodsOptionSlice";
import veryShorCountReducer from "../RunningPeriodsCount/countSlice"
import dialogReducer from "../Common/Slices/DialogSlice";
import settingsReducer from "../Settings/Slice";
import { listenerMiddleware } from "./listenerMiddleware";

const rootReducer = combineReducers({
    devices: deviceReducer,
    alarms: alarmReducer,
    sidebar: sidebarReducer,
    dashboard: dashboardReducer,
    params:paramsReducer,
    auth:authReducer,
    options:optionsReducer,
    machineTimes:machineTimesReducer,
    runningPeriodOptions:runningPeriodsOptionsReducer,
    machineHealth:machineHealthReducer,
    mdc: mdcReducer,
    menu: menuReducer,
    veryShortCount: veryShorCountReducer,
    dialog: dialogReducer,
    settings: settingsReducer,
});

export const store = configureStore({
    reducer: rootReducer,
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware().concat(listenerMiddleware.middleware),
});

export type RootState = ReturnType<typeof store.getState>;

// export type AppThunk = ThunkAction<void, RootState, null, Action<string>>;
export type AppDispatch = typeof store.dispatch;



